import * as styles from './admin-badge.css.ts'

/**
 * Marks the signed-in user as an organization admin.
 *
 * Render it only for users who hold the role — there is no counterpart badge for everyone else,
 * because the menu is where a user self-diagnoses "why can't I edit this?", and a badge on every
 * account would answer that question for nobody.
 */
export const AdminBadge: React.FC = () => {
  return <span className={styles.adminBadge}>Admin</span>
}
